import { render, staticRenderFns } from "./TogglePieChart.vue?vue&type=template&id=dacc6cde&scoped=true&"
import script from "./TogglePieChart.vue?vue&type=script&lang=js&"
export * from "./TogglePieChart.vue?vue&type=script&lang=js&"
import style0 from "./TogglePieChart.vue?vue&type=style&index=0&id=dacc6cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacc6cde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSimpleTable } from 'vuetify/lib'
installComponents(component, {VIcon,VRow,VSimpleTable})
